export default "__VITE_ASSET__C0BCUha9__"